var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOutlineNavigateWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5fhuu7weza",
    d: "M9.706 3.293c.36.36.388.928.083 1.32l-.083.094L5.412 9h7.586c4.882 0 8.856 3.887 8.997 8.735l.003.265v2c0 .552-.447 1-1 1-.512 0-.935-.386-.993-.883L19.998 20v-2c0-3.785-3.004-6.87-6.759-6.996L13 11H5.412l4.293 4.293c.39.39.39 1.024 0 1.414-.361.36-.928.388-1.32.083l-.095-.083-6-6-.053-.058-.072-.094-.043-.07-.053-.114-.036-.105-.025-.12-.009-.09.001-.131.018-.126.03-.111.043-.111.052-.098.064-.092c.03-.037.055-.066.083-.094l6-6c.39-.39 1.024-.39 1.415 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#5fhuu7weza"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineNavigateWhite);
export default __webpack_public_path__ + "static/media/icon-outline-navigate-white.a810757854bdd5532b8a22fe4dc1e0ec.svg";
export { ForwardRef as ReactComponent };